import {
  CREATE_TRANSACTION_ACCOUNT,
  CREATE_TRANSACTION_ACCOUNT_SUCCESS,
  CREATE_TRANSACTION_ACCOUNT_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  transactionsAccount: {},
};

const createTransactionAccountReducer = (state = INIT_STATE, action) => {
  switch (action?.type) {
    case CREATE_TRANSACTION_ACCOUNT:
      return { ...state, loading: true };
    case CREATE_TRANSACTION_ACCOUNT_SUCCESS:
      return {
        ...state,
        transactionsAccount: action?.payload,
        loading: false,
      };
    case CREATE_TRANSACTION_ACCOUNT_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default createTransactionAccountReducer;